const getOrganizerFromLocationConfigurations = (memberships, locationKind, locationConfigurations) => {
  if (locationConfigurations) {
    const locationConfiguration = locationConfigurations.find((config) => config.kind === locationKind)
    if (locationConfiguration && locationConfiguration.organizer_user_id) {
      const membership = memberships.find((mem) => mem.user_id === locationConfiguration.organizer_user_id)
      if (membership) {
        return membership
      }
    }
  }

  return undefined
}

export const getCurrentOrganizer = (
  memberships,
  locationKind,
  pusherMembershipId,
  locationConfigurations = undefined
) => {
  let organizer
  organizer = getOrganizerFromLocationConfigurations(memberships, locationKind, locationConfigurations)

  if (organizer) { return organizer }

  if (memberships && memberships.length) {
    const pusherMembership = memberships.find(({ id }) => id === pusherMembershipId)

    if (locationKind === 'google_conference') {
      const googleMembership = memberships.find((membership) => membership.google_conferencing_configured === true)
      organizer = pusherMembership || googleMembership
    } else if (locationKind === 'microsoft_teams_conference') {
      const teamsMembership = memberships.find((membership) => membership.is_microsoft_teams_configured === true)
      organizer = pusherMembership || teamsMembership
    } else {
      organizer = memberships.find((membership) => membership.location_organizer)
    }

    return organizer || memberships[0]
  }

  return null
}
